import React from 'react';
import {
  Hero,
  About,
  Services,
  Featured,
  Promo,
  New,
  Blogs,
  WhyUs,
  Contact,
  Tips,
  Testimonials,
  Galleries,
} from '../container';
import Masonry from '../container/Masonry';

const Home = () => {
  return (
    <>
      <Hero />
      <Featured />
      <About />
      <Services />
      <Masonry />
      <New />
      <Testimonials />
      <Promo />
      <Blogs />
      <Tips />
      <WhyUs />
      <Contact />
      <Galleries/>
    </>
  );
};

export default Home;
